import { Button, Flex, Typography } from 'antd';
import styles from './IntroStep.module.css';

const { Text, Title } = Typography;

interface IntroStepProps {
  onStart: () => void;
  onCancel?: () => void;
  isLoading: boolean;
}

export const IntroStep = ({ onStart, onCancel, isLoading }: IntroStepProps) => (
  <Flex vertical gap={16}>
    <Title level={5}>Enable Two-Factor Authentication</Title>
    <Text type="secondary">
      Add an extra layer of security to your account by requiring a verification
      code from your authenticator app when signing in.
    </Text>
    <Text type="secondary">
      You will need an authenticator app such as Google Authenticator, Authy, or
      1Password.
    </Text>
    <Flex gap={8} className={styles.buttonGroup}>
      <Button
        type="primary"
        onClick={onStart}
        loading={isLoading}
        className={styles.actionButton}
      >
        Set up MFA
      </Button>
      {onCancel && (
        <Button onClick={onCancel} className={styles.actionButton}>
          Cancel
        </Button>
      )}
    </Flex>
  </Flex>
);
